import React, { Component } from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import './App.css';

// import OSUNavBar from '../OSUNavBar/OSUNavBar';
import OSUNavBar from 'react-osu-navbar';
import ProtectedRouteContainer from '../../containers/Common/ProtectedRoute/ProtectedRouteContainer';
import SidebarContainer from "../../containers/Sidebar/SidebarContainer";
import RulesContainer from '../../containers/Rules/RulesContainer';
import AuditContainer from '../../containers/Audit/AuditContainer';
import StatsContainer from '../../containers/Stats/StatsContainer';
import CreateRuleContainer from '../../containers/CreateRule/CreateRuleContainer';
import SigninContainer from '../../containers/Signin/SigninContainer';
import SignOut from '../SignOut/SignOut';
import Unauthorized from '../Unauthorized/Unauthorized';
import Amplify, { Auth } from 'aws-amplify';
import IdleTimer from 'react-idle-timer'
import apiConfig from '../../api-config';
import aws_exports from '../../aws-exports';
import CustomAuthStorage from '../../util/CustomAuthStorage';
import 'react-select/dist/react-select.css';

Auth.configure({storage:new CustomAuthStorage(apiConfig.customAuthStorage)});
Amplify.configure({...aws_exports, ...apiConfig});

class App extends Component {

  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.onIdle = this._onIdle.bind(this)
  }


  _onIdle(e) {
    console.log('user is idle', e);
    console.log('last active', this.idleTimer.getLastActiveTime());
    Auth.signOut();
  }

  render() {
    return (
      <IdleTimer ref={ref => { this.idleTimer = ref }}
      onIdle={this.onIdle}
      timeout={60000 * 30}>

      <div>

        <OSUNavBar/>
        <div id="application" className="no-right-margin row">
          <div id="sidebar-parent" className="no-right-padding">
            <SidebarContainer />
            
          </div>
          <main className="body-container no-horizontal-padding">
            <Switch>
              <Route exact path="/signin" component={SigninContainer} />
              <Route exact path="/signout" component={SignOut} />
              <Route exact path="/unauthorized" component={Unauthorized} />
              <ProtectedRouteContainer path="/rules" component={RulesContainer} />
              <ProtectedRouteContainer path="/audit/:id" component={AuditContainer} />
              <ProtectedRouteContainer path="/create" component={CreateRuleContainer} />
              <ProtectedRouteContainer path="/processing" component={StatsContainer} />
              <Route exact path="/" render={() => (<Redirect to="/rules" />)} />
              <Route render={() => (
                <div>
                  <h1>404 Not Found</h1>
                  <div>This isn't the route you are looking for. Move Along.</div>
                </div>
              )} />
            </Switch>
          </main>

        </div>
        
      </div>
      </IdleTimer>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js